export default "__VITE_ASSET__6xy3GJJ0__"